import { useContext } from "react";
import constants from "../constants";
import TestDueHooks from "./TestDueHooks";
import { useLocation } from "react-router-dom";
import LeftNavBarHooks from "./LeftNavBarHooks";
import AlertContext from "../context/AlertContext";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import { isEdge, isChrome, isFirefox, isSafari } from "react-device-detect";

export default function WarningNoticeHooks() {
  const Alert = useContext(AlertContext);

  const { openTest } = LeftNavBarHooks();
  const { currentDueLabel } = TestDueHooks();
  const { handleClose } = useCommonFunctionHooks();

  const { pathname } = useLocation();

  const showCompleteSvgIcon = () => {
    return (
      Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
      Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
      Alert.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED
    );
  };

  const showWarningForAssessment = () => {
    return (
      Alert.isVersionUpToDate ||
      (!Alert.lpData.mode &&
        pathname === "/home" &&
        Alert.lpData.mode !== undefined &&
        (isEdge || isChrome || isSafari || isFirefox) &&
        (Alert.testData.status === constants.PROGRESS_STATUS.UNLOCKED ||
          Alert.testData.status === constants.PROGRESS_STATUS.REATTEMPT ||
          Alert.testData.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION ||
          Alert.testData.status === constants.PROGRESS_STATUS.IN_PROGRESS ||
          Alert.testData.status === constants.PROGRESS_STATUS.QN_CONTINUE) &&
        (Alert.testData.proctored === constants.PROCTORING_MODE.TAB ||
          Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM || 
          Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC ||
          Alert.testData.proctored === constants.PROCTORING_MODE.DUAL))
    );
  };

  const getMainDivClassNameForWarningNotice = () => {
    return showWarningForAssessment() ||
      (Alert.status !== constants.PROGRESS_STATUS.EVALUATED &&
        currentDueLabel(Alert.testData.duedate) === "Past Due" &&
        Alert.status !== constants.PROGRESS_STATUS.TO_BE_EVALUATED &&
        Alert.status !== constants.PROGRESS_STATUS.PARTIAL_EVALUATED)
      ? "warningNoticeForPastDue"
      : Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
      ? "warningNoticeForResume"
      : Alert.status === constants.PROGRESS_STATUS.REATTEMPT || Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION
      ? "warningNoticeForRetake"
      : Alert.status === constants.PROGRESS_STATUS.IN_PROGRESS
      ? "warningNoticeForConductTrainer"
      : "warningNoticeSubmission";
  };

  const currentTestDue = (type, name) => {
    if (type === constants.libTypeIds.MCQ) {
      return name === "name"
        ? "MCQ"
        : name === "test"
        ? "MCQ test"
        : "MCQ Assessment Past Due";
    } else if (type === constants.libTypeIds.DESCRIPTIVE) {
      return name === "name"
        ? "Descriptive"
        : name === "test"
        ? "Descriptive test"
        : "Descriptive Assessment Past Due";
    } else if (type === constants.libTypeIds.CODING_SNIPPET) {
      return name === "name"
        ? "Coding Snippet"
        : name === "test"
        ? "Coding Snippet test"
        : "Coding Snippet Assessment Past Due";
    } else if (type === constants.libTypeIds.CODING_CHALLENGE) {
      return name === "name"
        ? "Coding"
        : name === "test"
        ? "Coding test"
        : "Coding Assessment Past Due";
    } else {
      return name === "name" || name === "test"
        ? "Assignment"
        : "Assignment Past Due";
    }
  };

  const goToNextTest = () => {
    let modules = Alert.lpData.modules;

    let moduleIndex = modules.findIndex(
      (modules) => modules.modid === Alert.module.id
    );

    if (moduleIndex === -1) {
      console.error("Invalid module ID");
      return;
    }

    let testIndex = modules[moduleIndex].data.findIndex(
      (test) => test.testid === Alert.testId || test.libid === Alert.testId
    );

    if (testIndex === -1) {
      console.error("Invalid test ID");
      return;
    }

    testIndex++;

    if (testIndex >= modules[moduleIndex].data.length) {
      testIndex = 0;
      moduleIndex++;

      if (moduleIndex >= modules.length) {
        moduleIndex = 0;
      }
    }
    while (
      modules[moduleIndex]?.data[testIndex]?.status ===
      constants.PROGRESS_STATUS.LOCKED
    ) {
      testIndex++;

      if (testIndex >= modules[moduleIndex].data.length) {
        testIndex = 0;
        moduleIndex++;

        if (moduleIndex >= modules.length) {
          moduleIndex = 0;
        }
      }
    }

    Alert.setModule({
      id: modules[moduleIndex].modid,
      name: modules[moduleIndex].modname,
    });

    openTest(modules[moduleIndex].data[testIndex]);
  };

  const downloadApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    if (/Linux/i.test(userAgent)) {
      return "Linux";
    }

    handleClose();

    if (/Win/i.test(userAgent)) {
      if (process.env.REACT_APP_NODE_API.includes("localhost")) {
        return "https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/Electron_app/localhost/Gradious+LMS.exe";
      } else if (process.env.REACT_APP_NODE_API.includes("cau354vyd1")) {
        return "https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/Electron_app/testenv/Gradious+LMS.exe";
      } else {
        return "https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/Electron_app/leap/Gradious+LMS.exe";
      }
    }

    if (/Mac/i.test(userAgent)) {
      if (process.env.REACT_APP_NODE_API.includes("localhost")) {
        return "https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/Electron_app/localhost/Gradious+LMS.dmg";
      } else if (process.env.REACT_APP_NODE_API.includes("cau354vyd1")) {
        return "https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/Electron_app/testenv/Gradious+LMS.dmg";
      } else {
        return "https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/Electron_app/leap/Gradious+LMS.dmg";
      }
    }

    return "Unknown OS";
  };

  return {
    downloadApp,
    goToNextTest,
    currentTestDue,
    showCompleteSvgIcon,
    showWarningForAssessment,
    getMainDivClassNameForWarningNotice,
  };
}
